import React, { useCallback, useMemo } from 'react';
import { Switch } from 'react-router';

import Toolbar from '@material-ui/core/Toolbar';

import LayoutContextProvider from 'pages/Layout/context';
import Drawer from 'pages/Layout/Drawer';
import { Footer } from 'pages/Layout/Footer';
import { Header } from 'pages/Layout/Header';
import Home from 'pages/Private/Home';
import { AcessCodeCheck } from 'pages/Public/AcessCode';
import { AccessControlRoutes } from 'routes/roles/AccessControl';
import { CashierRoutes } from 'routes/roles/CashierRoutes';
import { ConferenceRoutes } from 'routes/roles/ConferenceRoutes';
import { FavoritesRoutes } from 'routes/roles/FavoritesRoutes';
import { InHomeRoutes } from 'routes/roles/InHomeRoutes';
import { InvoicesRoutes } from 'routes/roles/InvoicesRoutes';
import { ReceiptRoutes } from 'routes/roles/ReceiptRoutes';
import { RegisterRoutes } from 'routes/roles/RegisterRoutes';
import { ReportRoutes } from 'routes/roles/ReportRoutes';
import { ShoppingRoutes } from 'routes/roles/ShoppingRoutes';
import { StockRoutes } from 'routes/roles/StockRoutes';
import { StockSalesRoutes } from 'routes/roles/StockSalesRoutes';
import { Route } from 'routes/Route';

import { useStyles } from './styles';

const Private = () => {
  const classes = useStyles();

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null);
  const [drawerOpen, setDrawerOpen] = React.useState(false);

  const menuId = 'primary-search-account-menu';
  const mobileMenuId = 'primary-search-account-menu-mobile';

  const handleDrawerToggle = useCallback(() => {
    setDrawerOpen((prevState) => !prevState);
  }, []);

  const contextValue = useMemo(
    () => ({
      anchorEl,
      setAnchorEl,
      mobileMoreAnchorEl,
      setMobileMoreAnchorEl,
      menuId,
      mobileMenuId,
      drawerOpen,
      handleDrawerToggle,
    }),
    [
      anchorEl,
      setAnchorEl,
      mobileMoreAnchorEl,
      setMobileMoreAnchorEl,
      menuId,
      mobileMenuId,
      drawerOpen,
      handleDrawerToggle,
    ],
  );

  return (
    <LayoutContextProvider value={contextValue}>
      <div className={classes.root}>
        <Header />
        <Drawer />
        <main className={classes.main}>
          <div className={classes.content}>
            <Toolbar />
            <Switch>
              <Route isPrivate path='/code_acess' component={AcessCodeCheck} />
              <Route isPrivate path='/home' component={Home} />
              <Route isPrivate path='/reports' component={ReportRoutes} />
              <Route isPrivate path='/cashier' component={CashierRoutes} />
              <Route isPrivate path='/favoritos' component={FavoritesRoutes} />
              <Route isPrivate path='/access-control' component={AccessControlRoutes} />
              <Route isPrivate path='/stock' component={StockRoutes} />
              <Route isPrivate path='/invoices' component={InvoicesRoutes} />
              <Route isPrivate path='/stock-sales' component={StockSalesRoutes} />
              <Route isPrivate path='/shopping' component={ShoppingRoutes} />
              <Route isPrivate path='/receipt' component={ReceiptRoutes} />
              <Route isPrivate path='/conference' component={ConferenceRoutes} />
              <Route isPrivate path='/register' component={RegisterRoutes} />
              <Route isPrivate path='/in-home' component={InHomeRoutes} />
            </Switch>
          </div>
          <Footer />
        </main>
      </div>
    </LayoutContextProvider>
  );
};

export default Private;
